module.exports = __webpack_public_path__ + "static/media/7.1.89e1f032.zip";